import layoutHeaderAside from '@/layout/header-aside'
const meta = { auth: true }
export default {
  path: '/topic/',
  name: 'topic',
  meta,
  redirect: { name: 'topic-library' },

  component: layoutHeaderAside,
  children: (pre => [
    {
      path: 'new',
      name: 'topic-new',
      meta: {
        title: '选题申报',
        auth: true
      },
      // component: () => import('@/views/cep/topic-calendar/new')
      component: () => import('@/views/cep/insight/topicUp')
    },
    {
      path: 'review',
      name: 'topic-review',
      meta: {
        title: '选题管理',
        auth: true
      },
      component: () => import('@/views/cep/topic/review')
    },
    {
      path: 'calendar',
      name: 'topic-calendar-date',
      meta: {
        title: '选题日历',
        auth: true
      },
      component: () => import('@/views/cep/topic-calendar/index')
    },
    {
      path: 'library',
      name: 'topic-library',
      meta: {
        title: '选题库',
        auth: true
      },
      component: () => import('@/views/cep/topic/library')
    },
    {
      path: 'my',
      name: 'topic-my',
      meta: {
        title: '我的选题',
        auth: true
      },
      component: () => import('@/views/cep/topic/my')
    },
    {
      path: 'article/submit-review',
      name: 'article/submit-review',
      meta: {
        title: '投稿审核',
        auth: true
      },
      component: () => import('@/views/cep/article/submitReview')
    },
    {
      path: 'info',
      name: 'topic-info',
      meta: {
        title: '选题详情',
        auth: true
      },
      component: () => import('@/views/cep/topic/info')
    }
  ])('topic/')
}
